import { render, staticRenderFns } from "./BoardingClassChartFilter.vue?vue&type=template&id=649546d6&scoped=true&"
import script from "./BoardingClassChartFilter.vue?vue&type=script&lang=js&"
export * from "./BoardingClassChartFilter.vue?vue&type=script&lang=js&"
import style0 from "./BoardingClassChartFilter.vue?vue&type=style&index=0&id=649546d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649546d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VRow,VSelect})
